import { PaymentMethodFundingSources, PaymentMethodFundingSource } from '../../types/PaymentsButtonViewConfig';

export const MIN_AMOUNT_OF_TOP_LEVEL_BUTTONS = 2;

export type PaymentMethodConfig = {
  name: PaymentMethodFundingSource;
  priority: number;
  canBeHidden: boolean;
};

export const buttonsViewConfig: Record<PaymentMethodFundingSource, PaymentMethodConfig> = {
  [PaymentMethodFundingSources.ApplePay]: {
    name: PaymentMethodFundingSources.ApplePay,
    priority: 0,
    canBeHidden: false,
  },
  [PaymentMethodFundingSources.PayPal]: {
    name: PaymentMethodFundingSources.PayPal,
    priority: 10,
    canBeHidden: false,
  },
  [PaymentMethodFundingSources.PayPalCredit]: {
    name: PaymentMethodFundingSources.PayPalCredit,
    priority: 20,
    canBeHidden: true,
  },
  [PaymentMethodFundingSources.PayPalPayLater]: {
    name: PaymentMethodFundingSources.PayPalPayLater,
    priority: 30,
    canBeHidden: true,
  },
  [PaymentMethodFundingSources.PayPalVenmo]: {
    name: PaymentMethodFundingSources.PayPalVenmo,
    priority: 40,
    canBeHidden: true,
  },
  [PaymentMethodFundingSources.GooglePay]: {
    name: PaymentMethodFundingSources.GooglePay,
    priority: 50,
    canBeHidden: true,
  },
};
